import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() icon!: string;
  @Input() headerText!: string;
  @Input() paraText!: string;
}
